<script setup>
import {computed, onMounted} from 'vue'
import { useContractsStore } from '@/stores/contract.js'
import { useRoute } from 'vue-router'
import Split from '@/layouts/split.vue'
import Comments from '@/components/Comments.vue'
import DocList from '@/components/documents/DocList.vue'
import ContractDetails from "@/components/contract/ContractDetails.vue";
import FilesList from "@/components/common/FilesList.vue";

const route = useRoute()
const contractsStore = useContractsStore()
const contract = computed(() => contractsStore.contract)

onMounted(() => {
  contractsStore.loadContract(route.params.id);
});

const contractId = route.params.id;
</script>
<template>
  <Split>
    <template #main>
      <ContractDetails :contract-id="contractId" />
      <div class="flex flex-col lg:flex-row gap-4 pt-4">
        <DocList target="contract" :entity-id="Number(contractId)" class="basis-1/2 shrink-0"/>
        <FilesList target="contract" :entity-id="Number(contractId)" class="basis-1/2 shrink-0"/>
      </div>
    </template>

    <template #sidebar>
      <Comments
          class="flex-1 min-h-0"
          target="contract"
          :entity-id="route.params.id"
          :currentUserName="'Вы'"
      />

    </template>

  </Split>

</template>